var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntranceN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 501 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.494472,
    y: 0.494472,
    width: 185.153,
    height: 36.779,
    transform: "matrix(-1 0 0 1 499.113 217.958)",
    fill: "#316CF0",
    stroke: "black",
    strokeWidth: 0.988944
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.494472,
    y: 0.494472,
    width: 185.153,
    height: 36.779,
    transform: "matrix(-1 0 0 1 499.113 169.4)",
    fill: "#316CF0",
    stroke: "black",
    strokeWidth: 0.988944
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.494472,
    y: 0.494472,
    width: 185.153,
    height: 36.779,
    transform: "matrix(-1 0 0 1 499.113 263.82)",
    fill: "#316CF0",
    stroke: "black",
    strokeWidth: 0.988944
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.631933,
    y: 0.631933,
    width: 25.7132,
    height: 25.7132,
    transform: "matrix(-1 0 0 1 493.439 223.353)",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.631933,
    y: 0.631933,
    width: 25.7132,
    height: 25.7132,
    transform: "matrix(-1 0 0 1 493.439 174.795)",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.631933,
    y: 0.631933,
    width: 25.7132,
    height: 25.7132,
    transform: "matrix(-1 0 0 1 493.439 269.215)",
    fill: "#A0BDFF",
    stroke: "#0F172A",
    strokeWidth: 1.26387
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.945 314.736V266.657V314.736Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.945 314.736V266.657",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.326 196.05H366.348V363.871H206.998",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.326 196.05H366.348V363.871H206.998",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M309.841 229.435C317.332 229.436 324.654 231.659 330.882 235.821C337.11 239.984 341.964 245.899 344.831 252.819C347.696 259.74 348.444 267.355 346.982 274.701C345.52 282.047 341.913 288.795 336.616 294.092C331.32 299.388 324.572 302.995 317.226 304.457C309.88 305.92 302.265 305.171 295.344 302.306C287.245 298.955 280.56 292.898 276.427 285.169C272.294 277.44 270.969 268.516 272.679 259.92C274.39 251.323 279.028 243.586 285.805 238.027C292.581 232.468 301.076 229.431 309.841 229.435Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.807 293.833C286.332 290.236 290.539 287.379 295.181 285.428C299.824 283.478 304.809 282.474 309.845 282.475C314.881 282.474 319.866 283.478 324.509 285.428C329.152 287.379 333.358 290.236 336.883 293.833C333.356 297.426 329.149 300.281 324.507 302.23C319.864 304.179 314.88 305.183 309.845 305.184C304.81 305.184 299.826 304.18 295.183 302.231C290.541 300.282 286.333 297.427 282.807 293.833Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310.174 275.695C306.35 275.695 302.682 274.176 299.978 271.472C297.273 268.767 295.754 265.1 295.754 261.275C295.754 257.451 297.273 253.783 299.978 251.079C302.682 248.375 306.35 246.855 310.174 246.855C313.998 246.855 317.666 248.375 320.37 251.079C323.075 253.783 324.594 257.451 324.594 261.275C324.594 265.1 323.075 268.767 320.37 271.472C317.666 274.176 313.998 275.695 310.174 275.695Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.947 53.9723V17.1807H366.348V185.002H230.45",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.947 53.9723V17.1807H366.348V185.002H230.45",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.008 77.4922H146.361H238.008Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238.008 77.4922H146.361",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.008 90.2881H146.361H238.008Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.008 90.2881H146.361",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M238.008 103.193H146.361H238.008Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M238.008 103.193H146.361",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.424 50.4365C312.253 50.4359 322.639 54.7372 330.297 62.3941C337.955 70.0511 342.257 80.4365 342.258 91.2656C342.258 102.095 337.957 112.481 330.3 120.139C322.643 127.796 312.258 132.099 301.429 132.1C290.6 132.1 280.214 127.799 272.556 120.142C264.898 112.485 260.595 102.1 260.595 91.2704C260.594 80.4412 264.895 70.0553 272.552 62.3975C280.209 54.7396 290.595 50.4372 301.424 50.4365Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M272.28 119.857C276.079 115.98 280.614 112.899 285.619 110.796C290.623 108.694 295.997 107.61 301.425 107.61C306.854 107.61 312.228 108.694 317.232 110.796C322.237 112.899 326.771 115.98 330.57 119.857C326.769 123.731 322.234 126.808 317.23 128.908C312.225 131.009 306.853 132.091 301.425 132.091C295.998 132.091 290.625 131.009 285.621 128.908C280.617 126.808 276.082 123.731 272.28 119.857Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M301.788 99.6272C297.666 99.6272 293.712 97.9896 290.797 95.0746C287.882 92.1596 286.245 88.2061 286.245 84.0836C286.245 79.9612 287.882 76.0076 290.797 73.0927C293.712 70.1777 297.666 68.54 301.788 68.54C305.911 68.54 309.864 70.1777 312.779 73.0927C315.694 76.0076 317.332 79.9612 317.332 84.0836C317.332 88.2061 315.694 92.1596 312.779 95.0746C309.864 97.9896 305.911 99.6272 301.788 99.6272Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 335.345C287.088 347.553 267.718 335.08 277.956 317.859L299.777 335.345Z",
    fill: "#FECFC4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 335.345C287.088 347.553 267.718 335.08 277.956 317.859L299.777 335.345Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M277.668 317.628C264.964 329.968 245.46 317.421 255.826 300.126L277.668 317.628Z",
    fill: "#FECFC4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M277.668 317.628C264.964 329.968 245.46 317.421 255.826 300.126L277.668 317.628Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M220.618 211.705L335.147 303.48C338.857 306.356 341.621 310.278 343.083 314.74C344.544 319.202 344.635 323.999 343.345 328.513C342.487 331.51 341.042 334.307 339.093 336.74C337.143 339.173 334.73 341.194 331.992 342.685C329.255 344.176 326.248 345.108 323.147 345.425C320.046 345.741 316.913 345.438 313.931 344.531C310.948 343.624 308.175 342.134 305.773 340.145L190.52 247.789C203.003 238.037 213.264 225.735 220.618 211.705Z",
    fill: "#316CF0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M220.618 211.705L335.147 303.48C338.857 306.356 341.621 310.278 343.083 314.74C344.544 319.202 344.635 323.999 343.345 328.513C342.487 331.51 341.042 334.307 339.093 336.74C337.143 339.173 334.73 341.194 331.992 342.685C329.255 344.176 326.248 345.108 323.147 345.425C320.046 345.741 316.913 345.438 313.931 344.531C310.948 343.624 308.175 342.134 305.773 340.145L190.52 247.789C203.003 238.037 213.264 225.735 220.618 211.705Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M142.438 330.866L200.191 372.877C193.791 381.361 187.048 390.307 180.951 397.812L124.126 358.033C130.069 348.869 136.173 339.812 142.438 330.866Z",
    fill: "#90B1FB",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M191.249 265.101C208.22 242.391 231.253 223.19 242.701 220.797C254.15 218.404 264.173 220.534 268.063 231.002C271.688 231.769 275.084 233.373 277.981 235.684C280.877 237.995 283.194 240.95 284.747 244.315C295.506 245.033 305.187 248.49 308.986 261.517C320.426 263.122 329.333 272.278 330.943 280.167C332.244 286.434 331.728 292.941 329.455 298.924L311.548 284.577C305.354 289.119 287.415 302.643 281.878 307.969C267.012 322.271 245.435 349.792 224.08 343.44C219.796 346.846 210.454 359.271 200.191 372.881L142.437 330.864C160.802 304.606 177.24 283.857 191.249 265.101Z",
    fill: "#FECFC4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.248 265.101C208.217 242.391 231.252 223.19 242.7 220.797C254.148 218.404 264.172 220.534 268.062 231.002C271.687 231.769 275.083 233.373 277.98 235.684C280.876 237.995 283.193 240.95 284.746 244.315C295.505 245.035 305.186 248.492 308.985 261.517C320.425 263.124 329.383 272.27 330.942 280.167C332.262 286.432 331.745 292.945 329.454 298.924L311.547 284.577C305.353 289.119 287.414 302.643 281.876 307.969C267.011 322.273 245.434 349.79 224.079 343.44C219.795 346.846 210.453 359.271 200.189 372.881L142.436 330.864C160.801 304.606 177.239 283.854 191.248 265.101Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M308.988 261.518C299.999 260.046 289.604 261.745 273.13 276.78",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M268.066 231.002C253.614 228.073 243.084 237.609 234.719 246.208",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M252.893 259.853C256.595 254.928 261.413 250.952 266.95 248.251C272.487 245.55 278.586 244.201 284.746 244.314",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M122.287 271.244C61.023 271.244 11.3585 221.579 11.3585 160.316C11.3585 99.0523 61.023 49.3877 122.287 49.3877C183.55 49.3877 233.215 99.0523 233.215 160.316C233.215 221.579 183.55 271.244 122.287 271.244Z",
    fill: "white",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M122.284 58.2852C149.343 58.2865 175.293 69.0369 194.426 88.1714C213.558 107.306 224.306 133.257 224.305 160.316C224.303 187.375 213.553 213.325 194.418 232.457C175.284 251.59 149.333 262.338 122.274 262.336C95.2152 262.335 69.2651 251.584 50.1326 232.45C31.0001 213.315 20.2523 187.364 20.2537 160.305C20.2551 133.247 31.0054 107.297 50.1399 88.1641C69.2744 69.0316 95.2255 58.2838 122.284 58.2852Z",
    fill: "#90B1FB",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M162.638 118.992C155.361 113.912 147.145 110.333 138.469 108.463L136.541 108.475C135.447 105.956 134.885 103.235 134.889 100.489C134.602 94.9209 133.95 89.3774 132.936 83.8958C132.936 83.8958 149.686 80.4541 154.924 80.4541C159.558 80.452 164.049 82.0557 167.633 84.9924C171.218 87.929 173.674 92.017 174.583 96.5605C175.492 101.104 174.799 105.822 172.621 109.912C170.443 114.002 166.915 117.211 162.638 118.992Z",
    fill: "#183D98"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M162.638 118.992C155.361 113.912 147.145 110.333 138.469 108.463L136.541 108.475C135.447 105.956 134.885 103.235 134.889 100.489C134.602 94.9209 133.95 89.3774 132.936 83.8958C132.936 83.8958 149.686 80.4541 154.924 80.4541C159.558 80.452 164.049 82.0557 167.633 84.9924C171.218 87.929 173.674 92.017 174.583 96.5605C175.492 101.104 174.799 105.822 172.621 109.912C170.443 114.002 166.915 117.211 162.638 118.992Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.638 87.7917C127.564 87.7917 124.617 86.5708 122.443 84.3975C120.27 82.2242 119.049 79.2765 119.049 76.203C119.049 73.1295 120.27 70.1818 122.443 68.0085C124.617 65.8352 127.564 64.6143 130.638 64.6143C133.711 64.6143 136.659 65.8352 138.832 68.0085C141.006 70.1818 142.227 73.1295 142.227 76.203C142.227 79.2765 141.006 82.2242 138.832 84.3975C136.659 86.5708 133.711 87.7917 130.638 87.7917Z",
    fill: "#183D98"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M130.638 87.7917C127.564 87.7917 124.617 86.5708 122.443 84.3975C120.27 82.2242 119.049 79.2765 119.049 76.203C119.049 73.1295 120.27 70.1818 122.443 68.0085C124.617 65.8352 127.564 64.6143 130.638 64.6143C133.711 64.6143 136.659 65.8352 138.832 68.0085C141.006 70.1818 142.227 73.1295 142.227 76.203C142.227 79.2765 141.006 82.2242 138.832 84.3975C136.659 86.5708 133.711 87.7917 130.638 87.7917Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0962 123.849C99.4057 116.315 112.537 112.453 123.5 108.557L138.473 108.468C157.261 112.415 173.435 125.038 179.695 137.622C182.785 144.542 184.671 151.94 185.269 159.495C187.54 178.359 187.59 212.653 185.426 240.441C169.286 253.173 149.675 260.728 129.164 262.115C108.654 263.502 88.2036 258.655 70.4968 248.212C75.3363 212.731 82.1434 166.385 87.8768 137.548C88.8348 132.696 89.9229 127.638 93.0962 123.849Z",
    fill: "#2F68E9",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M128.273 122.596C119.115 183.894 123.948 136.272 113.658 261.981",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M145.508 110.378C145.074 117.408 145.035 124.455 145.396 131.489C145.396 131.489 135.209 133.78 132.055 134.402C137.689 139.01 139.58 140.183 143.596 143.728C134.214 163.408 126.067 184.45 118.469 202.398",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M115.331 111.414C114.364 118.036 112.529 124.501 109.874 130.644C112.866 131.305 118.225 132.81 121.215 133.468C117.106 136.694 112.786 139.642 108.286 142.295C108.286 142.295 114.835 185.404 118.471 202.396",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M162.835 185.407C162.835 209.642 163.133 249.807 162.01 254.304",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1154 183.457C100.153 200.901 102.509 203.651 99.4883 221.553C97.215 233.878 96.0404 246.379 95.9784 258.911",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M123.781 71.5376C124.339 70.5882 125.199 69.8537 126.224 69.4519C127.249 69.0502 128.38 69.0045 129.434 69.3223C130.488 69.6397 131.406 70.3018 132.039 71.2024C132.672 72.1031 132.985 73.1902 132.927 74.2898C132.744 76.8437 132.737 76.1913 132.905 77.2959C134.176 76.278 135.626 75.9766 136.187 76.6455C136.968 77.5684 135.599 79.887 133.431 80.7479C134.583 88.195 136.984 103.159 138.469 108.468C136.947 112.39 132.481 122.555 128.276 122.598C124.409 121.485 124.093 112.75 123.496 108.558C123.723 102.321 124.646 94.5623 125.051 87.6087C124.518 87.5096 123.998 87.3568 123.498 87.1503C118.797 85.255 121.997 74.3992 123.781 71.5376Z",
    fill: "#FECFC4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M123.781 71.5376C124.339 70.5882 125.199 69.8537 126.224 69.4519C127.249 69.0502 128.38 69.0045 129.434 69.3223C130.488 69.6397 131.406 70.3018 132.039 71.2024C132.672 72.1031 132.985 73.1902 132.927 74.2898C132.744 76.8437 132.737 76.1913 132.905 77.2959C134.176 76.278 135.626 75.9766 136.187 76.6455C136.968 77.5684 135.599 79.887 133.431 80.7479C134.583 88.195 136.984 103.159 138.469 108.468C136.947 112.39 132.481 122.555 128.276 122.598C124.409 121.485 124.093 112.75 123.496 108.558C123.723 102.321 124.646 94.5623 125.051 87.6087C124.518 87.5096 123.998 87.3568 123.498 87.1503C118.797 85.255 121.997 74.3992 123.781 71.5376Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M132.771 76.416C132.905 76.9247 132.955 77.4521 132.918 77.9769C132.827 79.3106 132.474 92.9082 124.804 91.2318C124.901 89.993 124.981 88.7811 125.049 87.6063C130.95 88.6716 132.383 80.4998 132.771 76.416Z",
    fill: "#316CF0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132.771 76.416C132.905 76.9247 132.955 77.4521 132.918 77.9769C132.827 79.3106 132.474 92.9082 124.804 91.2318C124.901 89.993 124.981 88.7811 125.049 87.6063C130.95 88.6716 132.383 80.4998 132.771 76.416Z",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M106.141 298.471H84.0884",
    stroke: "#0F172A",
    strokeWidth: 2.96683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1133 309.494V287.441",
    stroke: "#0F172A",
    strokeWidth: 2.96683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3203 276.777H47.2897",
    stroke: "#0F172A",
    strokeWidth: 2.96683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2969 282.79V270.762",
    stroke: "#0F172A",
    strokeWidth: 2.96683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M489.316 228.749L473.724 244.341",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M489.316 244.341L473.724 228.749",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M489.316 180.192L473.724 195.784",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M489.316 195.784L473.724 180.192",
    stroke: "#0F172A",
    strokeWidth: 1.26387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M473.121 285.4L477.168 289.446L489.307 277.307",
    stroke: "black",
    strokeWidth: 2.96683,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntranceN);
export default __webpack_public_path__ + "static/media/entrance_n.693ebd55641784301b57d43a95df5c5c.svg";
export { ForwardRef as ReactComponent };